<template>

<div class="-accordion accordion-flush">
    <div class="-accordion-item">
        <h2 class="accordion-header">
            <button 
                class="accordion-button"
                :class="{'collapsed': !_.assets}" 
                type="button" 
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne" 
                aria-expanded="false" 
                aria-controls="flush-collapseOne"
                @click="_.assets = !_.assets"
            >
                <span>Assets</span>
            </button>
        </h2>
        <div class="-accordion-collapse -collapse" data-v-if="_.assets">
            <div class="accordion-body">

                <kt-upload @process="processFiles($event)" multiple="1"></kt-upload>

                <table class="table table-sm table-striped mt-3" v-if="files.length">
                    <tbody>
                        <tr v-for="file in files">
                            <td>
                                <button class="btn btn-sm" @click="showDelete(file)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                            <td>
                                <a :href="'https://admin.7thleveltech.com/v1/Data/Download/' + file.Id"
                                    target="_blank">
                                    {{ file.Title }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</div>


</template>

<script setup>
import { ref, watch, onUnmounted } from "vue";
import Api from "@/services/Api";
import KtUpload from "@/components/UI/KtUpload.vue";

const _ = ref({});
const files = ref([]);
const unwatch = [];

const props = defineProps({
    request: {
        type: Number,
        default: 0
    },

    part: {
        type: Number,
        default: 0
    },

    expense: {
        type: Number,
        default: 0
    },

    mileage: {
        type: Number,
        default: 0
    },

    task: {
        type: Number,
        default: 0
    }
});

const load = async () =>
{
    // todo ... link the files to notes / parts / etc ...
    files.value = await Api.loadRequestFiles(props.request);
};

const processFiles = async (files) =>
{
    for (let i = 0; i < files.length; i++)
    {
        let file = files[i];
        var dta = new FormData();
        dta.append("File", file);

        let type = "request";

        if (props.part)
        {
            type = "part";
            dta.append("RefId", props.part);
        }

        else if (props.expense)
        {
            type = "expense";
            dta.append("RefId", props.expense);
        }

        else if (props.mileage)
        {
            type = "mileage";
            dta.append("RefId", props.mileage);
        }

        else if (props.task)
        {
            type = "task";
            dta.append("RefId", props.task);
        }

        dta.append("Type", type);
        dta.append("RequestId", props.request);

        // do we need anything else ...
        await Api.saveFile(dta);   
    }
    
    await load();
};

unwatch.push(watch(() =>
{
    return props.request
}, async (nv, ov) => 
{
    if (nv)
    {
        await load();
    }
}, { immediate: true }));

onUnmounted(() =>
{
    unwatch.forEach((un) =>
    {
        un();
    });
});


</script>